
import { Options, Vue } from "vue-class-component";
import { useRoute } from "vue-router";

@Options({
  props: {
    facebook: String,
    twitter: String,
    instagram: String,
    deezer: String,
    youtube: String,
    soundcloud: String,
    spotify: String,
  },
  methods: {
    styleLeft1() {
      if (this.$route.path.includes("no_media")) {
        return { "justify-content": "flex-start" };
      }
      if (
        this.facebook ||
        this.deezer ||
        this.twitter ||
        this.youtube ||
        this.spotify ||
        this.instagram ||
        this.soundcloud
      ) {
        return { display: "flex" };
      } else {
        return { display: "none" };
      }
    },
    styleLeft2() {
      return { "margin-left": "-10px" };
    },
    styleLeft3(color: string) {
      return { fill: color };
    },
  },
})
export default class SocialMediaButtons extends Vue {
  facebook!: string;
  twitter!: string;
  instagram!: string;
  deezer!: string;
  youtube!: string;
  soundcloud!: string;
  spotify!: string;
  route = useRoute();
}
